import { savedSearchRuleNo } from 'src/app/misc/saved-searches/helpers/get-formated-rules-values.helper';
import { ObjectNames } from './../../../../modules/shared/constants/object.names';
import { ConfigurationService } from './../../../../configurations/configurationService';
import { PermissionService } from './../../../../service/permission.service';
import { SharedChannelService } from './../../../../modules/shared/services/channel.service';
import { AccountModuleId, LeadModuleId } from './../../../../modules/shared/constants/modules.constant';
import { ParseHelper } from './../../../../modules/shared/parse.helper';
import { AppMainComponent } from './../../../../app.main.component';
import { DataTypeWithOperatorNS, DateTimeOperatorValue } from './../../../saved-searches/models/saved-search.static';
import { CUSTOMFIELD_TYPE_IDS } from './../../../../modules/shared/constants/typeId';
import { MultiSelectFieldsNS } from 'src/app/misc/saved-searches/models/saved-search-multiselect-fields.static';
import { AppMainService } from './../../../../app-main.service';
import { SavedSearchesService } from './../../../saved-searches/services/saved-searches.service';
import { LocalDatePipe } from './../../../../modules/shared/pipes/local-date.pipe';
import { Component, Input, Output, OnInit, EventEmitter, OnDestroy, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { Subject, debounceTime, distinctUntilChanged, takeUntil } from 'rxjs';
import { SavedSearchNS } from 'src/app/misc/saved-searches/models/saved-search.models';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { WorkflowModelsNS } from '../../models/add-update-workflow.models';
import { prepareSavedSearchAddEditFilter } from 'src/app/misc/saved-searches/helpers/prepare-saved-searh-filter.helper';
import { prepareSavedSearchRuleValues } from 'src/app/misc/saved-searches/helpers/prepare-saved-search-rule-values.helper';

@Component({
    selector: 'app-workflow-add-saved-search-rules',
    templateUrl: './workflow-add-saved-search-rules.component.html',
    styleUrls: ['./workflow-add-saved-search-rules.component.scss'],
    providers: [LocalDatePipe]
})
export class WorkflowAddSavedSearchRulesComponent implements OnInit, OnChanges, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displaySavedSearchRule: boolean = false;
    @Input() headerTitle: string = "Add Rules from Saved Search";
    @Input() moduleSelection: boolean = true;
    @Input() parentModules: SavedSearchNS.IObjectType[] = [];
    @Input() selectedParentModule: SavedSearchNS.IObjectType;
    @Input() parentTemplates: SavedSearchNS.ITemplate[] = [];
    @Input() selectedParentTemplate: SavedSearchNS.ITemplate;// Parent module Template
    @Input() selectedAccountChannel = null;
    @Input() selectedAssoModule: SavedSearchNS.IObjectType;
    @Input() selectedAssoTemplate: SavedSearchNS.ITemplate;
    @Input() selectedSavedSearch: WorkflowModelsNS.WorkflowEmailSavedSearchs;

    @Output() dialogClosed = new EventEmitter<boolean>();
    @Output() savedSearchRulesAdded = new EventEmitter<{selectedSavedSearch: any, addedRules: SavedSearchNS.IRuleList[], ruleCombination: string}>();

    @ViewChild('op', { static: false }) panel;

    //saved search
    searchControl = new FormControl();
    moduleSearchValue: string = '';
    savedSearchesList: SavedSearchNS.ISavedSearch[] = [];
    selectedSSName: string = 'Select a Save Search';
    globalFilterInput = 'allterritorys';
    gridState: any = {};
    searchValueAccount: string = '';
    isActive: boolean = true;
    totalRecords: number = 0;
    noSearchesFindOrLoadingText = 'No Saved Searches Found.';
    pageSize: number = 15;
    first: number = 0;
    pageNumber = 1;
    listCols: SavedSearchNS.IColumn[] = [
        { field: 'id', header: 'ID', show: false, value: '', checked: false, order: false, moveable: false, dataType: 'number' },
        { field: 'name', header: 'Name', objectNameList: 'name', show: true, value: '', checked: false, order: true, moveable: false, dataType: 'string' },
        { field: 'moduleName', header: 'Module', objectNameList: 'routeassignedto', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
        { field: 'templateName', header: 'Template', objectNameList: 'totaldistance', show: true, value: '', checked: false, order: false, moveable: false, dataType: 'string' },
    ];
    selectedSearch: SavedSearchNS.ISavedSearchOverview;

    //Rules
    users = [];
    choicesDD: SavedSearchNS.IChoice[] = [
        { id: 1, name: "And" },
        { id: 2, name: "Or" },
    ];
    dateTimeOperatorValue = DateTimeOperatorValue;
    booleanValueDD: SavedSearchNS.BooleanValue[] = [
        { id: 1, name: "true" },
        { id: 2, name: "false" },
    ];

    constructor(
        public app: AppMainComponent,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private savedSearchesService: SavedSearchesService,
        private localDatePipe: LocalDatePipe,
        private configService: ConfigurationService,
        private sharedChannelService: SharedChannelService,
        private permissionService: PermissionService
    ) {
        this.users = ParseHelper.DeepCopy(this.app.usersList);
    }

    ngOnInit(): void {
        this.searchSaveSearches();
    }

    ngOnChanges(changes: SimpleChanges): void {

        if (changes['parentModules'] && changes['parentModules']?.currentValue) {
            this.parentModules = changes['parentModules']?.currentValue;
        }

        if (changes['selectedParentModule'] && changes['selectedParentModule']?.currentValue) {
            this.selectedParentModule = changes['selectedParentModule']?.currentValue;
        }

        if (changes['selectedParentTemplate'] && changes['selectedParentTemplate']?.currentValue) {
            this.selectedParentTemplate = changes['selectedParentTemplate']?.currentValue;
        }

        if (changes['selectedAssoModule'] && changes['selectedAssoModule']?.currentValue) {
            this.selectedAssoModule = changes['selectedAssoModule']?.currentValue;
        }

        if (changes['selectedAssoTemplate'] && changes['selectedAssoTemplate']?.currentValue) {
            this.selectedAssoTemplate = changes['selectedAssoTemplate']?.currentValue;
        }

        if (changes['selectedAccountChannel'] && changes['selectedAccountChannel']?.currentValue) {
            this.selectedAccountChannel = changes['selectedAccountChannel']?.currentValue;
        }

        if(changes['selectedSavedSearch'] && changes['selectedSavedSearch']?.currentValue){
            this.selectedSavedSearch = changes['selectedSavedSearch']?.currentValue;

            if(this.selectedSavedSearch){
                this.setSelectedSavedSearch();
            }
        }
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }

    dialogClose() {
        this.displaySavedSearchRule = false;
        this.dialogClosed.emit(true);
    }

    onChangeParentModule(){
        this.getTemplateList(true, this.selectedParentModule, null);
        this.selectedSavedSearch = null;
        this.selectedSearch = null;
        this.selectedSSName = "Select a Save Search";
    }

    onChangeParentChannel(){
        this.getSavedSeachList(1, 15);
        this.selectedSavedSearch = null;
        this.selectedSearch = null;
        this.selectedSSName = "Select a Save Search";
    }

    searchSaveSearches() {
        this.searchControl.valueChanges.pipe(
            debounceTime(700),
            distinctUntilChanged())
            .subscribe(value => {
                this.moduleSearchValue = value.trim() ? value.trim() : '';
                this.onGlobalSearch();
            });
    }

    onGlobalSearch() {
        this.resetSavedSearchPagination();
        this.getSavedSeachList(1, 15);
    }

    setSelectedSavedSearch(){
        this.selectedParentModule = this.parentModules.find(module=> module.objectId==this.selectedSavedSearch.objectId);
        this.getTemplateList(true, this.selectedParentModule, null)
    }

    //get template list by module
    getTemplateList(isMainModuleModule: boolean, data: SavedSearchNS.IObjectType, mainModule: SavedSearchNS.SavedSearchRuleRequest) {

        if (data !== null) {
            this.appMainService.isShowSpinner('getTemplateList');

            if (data?.objectId === AccountModuleId || data?.objectId === LeadModuleId){
                this.sharedChannelService.getChannels(data?.objectId).subscribe({
                    next: (response) => {
                        this.appMainService.isHideSpinner('getTemplateList');
                        let channels = response || [];

                        switch (data?.objectId) {
                            case AccountModuleId:
                                channels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.ACCOUNT);
                                break;
                            case LeadModuleId:
                                channels = this.permissionService.filterChannelsByPermissions(channels,ObjectNames.LEAD);
                                break;
                            default:
                                break;
                        }

                        const processedData: any = channels.map((obj) => {
                            return {
                                id: obj?.id,
                                templateName: obj?.name,
                                channelName: obj?.name,
                                channelId: obj?.id,
                                objectId: data?.objectId
                            }
                        });
                        this.parentTemplates = processedData;
                        this.selectedParentTemplate = this.parentTemplates?.length>0 ? this.parentTemplates[0] : null;
                        if(this.selectedSavedSearch){
                            this.selectedParentTemplate = this.parentTemplates?.length>0 ? this.parentTemplates.find(template => template.channelId==this.selectedSavedSearch.channelId) : null;
                            this.searchControl.patchValue(this.selectedSavedSearch.saveSearchName);
                        }

                        this.getSavedSeachList(1, 15);
                    },
                    error: (error) => {
                        this.appMainService.isHideSpinner('getTemplateList');
                        this.messageService.add({
                            severity: 'error',
                            summary: 'Error',
                            detail: error?.error?.message ? error?.error?.message : 'Templates are not loaded, please try again...'
                        });

                    }
                  });
            }else{
                this.configService.getConfigurationsByTemplateName(`${data.name} Template`).pipe(takeUntil(this.ngUnsubscribe$)).subscribe(resp => {
                    this.appMainService.isHideSpinner('getTemplateList');
                    if (isMainModuleModule) {
                        if (mainModule?.templateId > 0) {
                            this.parentTemplates = resp.templates?.filter(x => x.isActive == true || x.id == mainModule?.templateId) ?? [];
                        }
                        else {
                            this.parentTemplates = resp.templates?.filter(x => x.isActive == true);
                        }
                        this.parentTemplates = this.parentTemplates.map(x => { x.objectId = resp.configuration?.objectId; return x; });
                        this.selectedParentTemplate = this.parentTemplates?.length>0 ? this.parentTemplates[0] : null;

                        if(this.selectedSavedSearch){
                            this.selectedParentTemplate = this.parentTemplates?.length>0 ? this.parentTemplates.find(template => template.channelId==this.selectedSavedSearch.channelId) : null;
                            this.searchControl.patchValue(this.selectedSavedSearch.saveSearchName);
                        }

                        this.getSavedSeachList(1, 15);
                    }
                },
                error => {
                    this.appMainService.isHideSpinner('getTemplateList');
                });
            }
        }
    }

    saveSavedSearchRule() {
            const ruleData: SavedSearchNS.IRuleList[] = [];
            this.selectedSearch.savedSearchRuleRequest.map((rule: any)=>{
            let ruleNo = rule?.ruleNo ? rule?.ruleNo : savedSearchRuleNo([...ruleData,...this.selectedSearch.savedSearchRuleRequest] as any[]);
            let choice = this.choicesDD.find(x => x.name == rule.operator);
            let eachRule: SavedSearchNS.IRuleList = {
                id: rule.id,
                ruleNo: ruleNo,
                module: this.getModuleAddEdit(rule),
                subModule: this.selectedAssoModule,
                template: { id: rule.templateId, templateName: rule.templateName, objectId: rule.objectId, channelId: rule.templateId, channelName: rule.templateName, isActive: true },
                filter: prepareSavedSearchAddEditFilter(rule),
                operator: { id: 1, name: rule.equation },
                value: rule.values,
                value2: null,
                choice: choice,
                isMainModule: rule.isMainModule,
                dataTypeWithOperator: this.getOperatorByDataTypeAddEdit(rule.dataType, rule.equation),
                valueLists: [],
                treeValueLists: [],
                objectId: rule.objectId,
                objectName: rule.objectName,
                valueRefId: rule.valueRefId,
                groupLabel: "",
                groupChildren: "",
                group: false,
                filtersDD: [],
                filtersDDTree: [],
                canEdit: true,
                accountChannel: this.selectedAccountChannel,
                compareWithField: rule?.compareWithField||false,
                comparisonCriteria: rule?.comparisonCriteria||null,
                comparisonCriteriaLabel: rule?.comparisonCriteriaLabel||null,
                comparisonCriteriaParentLabel: rule?.comparisonCriteriaParentLabel||null,
                isCustomComparisonCriteria: rule?.isCustomComparisonCriteria||false,
                comparisonCriteriaObject: rule?.comparisonCriteriaObject||null,
                customAttributeObjectId: rule?.customAttributeObjectId||null,
                comparisonCustomAttributeObjectId: rule?.comparisonCustomAttributeObjectId||null,

            };
            //****Prepare Value
            const { value, value2 } = prepareSavedSearchRuleValues(eachRule, this.app.usersList);
            eachRule.value = value;
            eachRule.value2 = value2;

            ruleData.push(eachRule);
        });

        this.savedSearchRulesAdded.emit({
            selectedSavedSearch: this.selectedSearch,
            addedRules: ruleData||[],
            ruleCombination:  this.selectedSearch.isCombinational ? this.selectedSearch.ruleCombination : null
        });
        this.dialogClose();
    }

    getSavedSearchListByFilter(event: LazyLoadEvent): void {
        if (!event.sortField && !event.filters) {
            if (event.first == 0 && event.rows == 15) {
                this.getSavedSeachList(1, 15);
                return;
            }
        }

        const pageSize: number = event.rows;
        const pageNumber: number = (event.first / event.rows) + 1;

        //if sort exist
        if (event.sortField) {
            const temp = {
                field: event.sortField,
                order: event.sortOrder
            }
            this.gridState['sort'] = temp;
        }
        //if column filter exist
        if (event.filters) {
            this.onFilterChange(event);
        }

        this.getSavedSeachList(pageNumber, pageSize);
    }

    //SavedSearch Table List
    getSavedSeachList(pageNumber: number, pageSize: number): void {
        let searchValue = '';
        const options: any = {};

        // apply field Filter
        if (this.gridState && this.gridState.filters && this.gridState.filters.length) {
            const filterColumns = [];
            this.gridState.filters.map(columnObj => {
                filterColumns.push(columnObj.field);
            });
            searchValue = this.gridState.filters && this.gridState.filters[0] && this.gridState.filters[0].value ? this.gridState.filters[0].value : '';

        }

        // apply sorting
        if (this.gridState && this.gridState.sort) {
            options.sort = {
                SortBy: this.gridState.sort.field,
                IsAscending: this.gridState.sort.order === 1 ? true : false
            }
        }

        options.moduleSearchValue = this.moduleSearchValue.length ? this.moduleSearchValue.trim() : searchValue||'';
        options.filter = {
            field: 'moduleName',
            value: this.selectedParentModule?.name
        }

        if(this.selectedParentModule?.objectId){
            options.moduleId = this.selectedParentModule?.objectId;
        }

        if(this.selectedParentTemplate?.channelId){
            options.channelId = this.selectedParentTemplate?.channelId;
        }

        this.appMainService.isShowSpinner('getSaveSearchList');
        this.savedSearchesService.getAllSavedSearchList(pageNumber, pageSize, this.isActive, options).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((response) => {
            let data = response.body == null ? [] : response.body;
            let headers = JSON.parse(response.headers.get('X-Pagination'));
            headers = headers == null ? [] : headers;
            this.totalRecords = headers['TotalCount'] || 0;

            if (data.length == 0) {
                this.noSearchesFindOrLoadingText;
            }

            this.savedSearchesList = this.processSaveSearchData(data);

            if(this.selectedSavedSearch){
                this.selectedSearch = (this.savedSearchesList.find(savedSearch=> savedSearch.id==this.selectedSavedSearch.saveSearchId)||null) as any;
                this.selectedSearch && this.onRowSelect(this.selectedSearch);
            }
            this.appMainService.isHideSpinner('getSaveSearchList');
        }, (error) => {
            this.appMainService.isHideSpinner('getSaveSearchList');
        });
    }

    resetSavedSearchPagination() {
        this.first = 0;
    }

    onFilterChange(event: LazyLoadEvent): void {
        const filters = [];
        for (const filterName in event.filters) {
            filters.push({
                field: filterName,
                value: event.filters[filterName].value
            });
        }
        this.gridState['filters'] = filters
    }

    onRowSelect(e) {
        this.selectedSavedSearch = null;
        this.selectedSSName = this.selectedSearch.name;
        this.panel.hide();

        this.appMainService.isShowSpinner('getSavedSearchById');
        this.savedSearchesService.getSavedSearchById(this.selectedSearch.id).pipe(takeUntil(this.ngUnsubscribe$)).subscribe((resp) => {
            this.appMainService.isHideSpinner('getSavedSearchById');
            this.selectedSearch.savedSearchRuleRequest = this.getViewRuleRequest(resp.savedSearchRule);

            const mainModule: SavedSearchNS.SavedSearchRuleRequest = this.selectedSearch.savedSearchRuleRequest.find(x => x.isMainModule == true);
            if(mainModule){
                this.selectedSearch.objectId = mainModule.objectId;
                this.selectedSearch.accountChannelId = mainModule.accountChannelId;
                if(!this.selectedSearch?.templateId){
                    this.selectedSearch.templateId = mainModule.templateId;
                }
            }
            this.selectedSearch.channelId = this.selectedSearch.templateId;
            this.selectedSearch.isCombinational = resp?.isCombinational||false;
            this.selectedSearch.ruleCombination = resp?.ruleCombination||false;
            this.selectedSearch.savedSearchUserPermission = resp.savedSearchUserPermission;
        }, (error) => {
            this.appMainService.isHideSpinner('getSavedSearchById');
        });
    }

    onRowUnselect(){
        this.selectedSSName = "Select a Save Search";
    }

    getViewRuleRequest(savedSearchRule: any[]): SavedSearchNS.SavedSearchRuleRequest[] {
        let ruleRequest: SavedSearchNS.SavedSearchRuleRequest[] = [];
        if (savedSearchRule) {
            savedSearchRule.forEach(element => {
                if (element?.dataType == 'Enum') {
                    if (element?.criteria?.toLowerCase() == 'territoryname') {
                        element.valuesJson = JSON.parse(element?.values[0]);
                    }
                }
                else if (element?.dataType == 'Distance') {
                    element.valuesJson = JSON.parse(element?.values[0]);
                }
                else {
                    element.valuesJson = null;
                }
                ruleRequest.push(element);
            });
        }
        if (ruleRequest) {
            ruleRequest = ruleRequest.sort((a, b) => (a.sequenceOrder > b.sequenceOrder) ? 1 : -1);
        }
        return ruleRequest;
    }

    //date convert
    processSaveSearchData(data: SavedSearchNS.ISavedSearch[]): any {
        return data.map((response) => {
            response.createdDate = this.localDatePipe.transform(response.createdDate, 'MM/DD/YYYY');
            const data = { ...response };
            return data;
        });
    }

    getModuleAddEdit(rule: SavedSearchNS.SavedSearchRuleRequest): SavedSearchNS.IObjectType {
        let parentModule: SavedSearchNS.IObjectType;
        if (rule.isMainModule) {
            parentModule = this.parentModules.find(x => x.objectId == rule.objectId);
        }
        else {
            parentModule = this.selectedParentModule?.childobject?.find(x => x.objectId == rule.objectId);
        }
        return parentModule;
    }

    getOperatorByDataTypeAddEdit(dataType: string, operator: string): DataTypeWithOperatorNS.ISavedSearchDataTypeWithOperator {
        let selectedDataTypeAndOperator = DataTypeWithOperatorNS.SavedSearchDataTypeWithOperator.find(x => x.DataType == dataType && x.Operator == operator);
        return selectedDataTypeAndOperator;
    }
}
